import type { MetricsReport } from '../lib/sync/metrics';
import { BASE_URL } from './http';

/** The report is tiny and never retried: a short cut-off keeps a weak line from holding it. */
const SEND_TIMEOUT_MS = 8_000;

/**
 * Feature 334 (US3): one waiting-time report per minute. The endpoint answers
 * 204 with no body, so this does not go through `request` (it parses JSON).
 * A device without a session sends nothing.
 */
export const clientMetricsApi = {
  async send(report: MetricsReport): Promise<void> {
    const token = localStorage.getItem('kitchen_jwt');
    if (!token) return;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), SEND_TIMEOUT_MS);
    try {
      const res = await fetch(`${BASE_URL}/client-metrics`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(report),
        signal: controller.signal,
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
    } finally {
      clearTimeout(timer);
    }
  },
};
